<template>
  <modal-form-helper :data="{...mdldata, title, enterSubmit: false}" :form="post">
    <template #title></template>
    <template #body>
      <div class="row mb-6">
        <div class="col-lg-6">
          <form-input v-model="post.name" :form="post" name="name" label="Project Name" :debounce="true"
                      :debounce-settings="{url: genUrl('projects', null, 'search'), route_name: 'project_details', param: 'name', label: 'name'}"/>
        </div>
        <div class="col-lg-6">
          <form-select2
              name="company"
              label="company"
              :form="post"
              v-model="post.company"
              :options="drdata.companies"
              :config="{
                    id: 'id',
                    label: 'name',
                    ajax: {
                      paginated: false,
                      url: genUrl('companies', null,  'search'),
                      term: 'name',
                    }
                  }"
              :classes="['form-select-solid form-select-sm']"
          >
            <template #labelText>Company<span><a v-if="source != 'overview'" class="ml-1 text-primary cursor-pointer"
                                                 @click="openModal('company_create', 'companies')"> (Add new)</a></span>
            </template>
          </form-select2>
          <!--          <form-treeselect v-model="post.company" :options="drdata.companies" label="Company"-->
          <!--                           :config="{id: 'id', label: 'name'}" :form="post" name="company">-->
          <!--            <template #labelText>Company<span><a class="ml-1 text-primary"-->
          <!--                                                 @click="openModal('company_create', 'companies')"> (Add new)</a></span>-->
          <!--            </template>-->
          <!--          </form-treeselect>-->
        </div>
      </div>


      <div class="row mb-6">


        <div class="col-lg-6">
          <form-select2
              name="project_type"
              label="Project Type"
              :form="post"
              @change="onTrxChange(post.project_type)"
              v-model="post.project_type"
              :options="drdata.transaction_types"
              :config="{
                    label: 'title',
                    searchable: false,
                    clearable: false,
                  }"
              :classes="['form-select-solid form-select-sm']"
          />
          <!--          <form-treeselect v-model="post.project_type" :options="drdata.transaction_types" label="Project Type"-->
          <!--                           :config="{id: 'id', label: 'title'}" :form="post" name="project_type"></form-treeselect>-->
        </div>

        <!--begin::Project Stage-->
        <div class="col-lg-6">
          <form-select2
              :disabled="!post.project_type"
              name="project_stage"
              label="Project Stage"
              :form="post"
              v-model="post.project_stage"
              :options="project_stages"
              :config="{
                    id: 'id',
                    label: 'name',
                    searchable: false,
                    clearable: false,
                  }"
              :classes="['form-select-solid form-select-sm']"
          />

        </div>
        <!--end::Project Stage-->
      </div>

      <div class="row mb-6" v-if="post.is_buyside_">
        <div class="col-lg-6">
          <form-select2
              name="working_for"
              label="Company Working For"
              :form="post"
              v-model="post.working_for"
              :options="drdata.companies_wf"
              :config="{
                    id: 'id',
                    label: 'name',
                    ajax: {
                      paginated: false,
                      url: genUrl('companies', null,  'search'),
                      term: 'name',
                    }
                  }"
              :classes="['form-select-solid form-select-sm']"
          >
          </form-select2>
        </div>
        <!--begin::Project Stage-->
        <div class="col-lg-6">
        </div>
        <!--end::Project Stage-->
      </div>

      <div class="row mb-6">
        <div class="col-lg-6">
          <form-select2
              name="introducers"
              label="Introducers"
              :required="false"
              :form="post"
              :template="userTemplate"
              :selection-template="userSelectionTemplate"
              v-model="post.introducers"
              :options="post.introducers_"
              :config="{
                    id: 'id',
                    label: 'name',
                    multiple: true,
                    ajax: {
                      paginated: true,
                      url: genUrl('users', null,  'search'),
                      term: 'query',
                    }
                  }"
              :classes="['form-select-solid form-select-sm']"
          >
          </form-select2>
          <!--          <form-treeselect v-model="post.introducer" :options="drdata.users" label="Introducers"-->
          <!--                           :config="{id: 'id', label: 'email', multiple: true}" :form="post"-->
          <!--                           name="introducers"></form-treeselect>-->
        </div>
        <div class="col-lg-6">
          <form-select2
              name="team_members"
              label="Team members"
              :required="false"
              :form="post"
              :template="userTemplate"
              :selection-template="userSelectionTemplate"
              v-model="post.team_members"
              :options="post.team_members_"
              :config="{
                    id: 'id',
                    label: 'name',
                    multiple: true,
                    ajax: {
                      paginated: true,
                      url: genUrl('users', null,  'search'),
                      term: 'query',
                    }
                  }"
              :classes="['form-select-solid form-select-sm']"
          >
          </form-select2>
        </div>
      </div>
      <div class="row mb-6">
        <div class="col-lg-6">
          <label for="buyer_categories" class="d-flex align-items-center dm-fs-0-9-rem fw-bold form-label mb-3">Buyer
            Categories</label>
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6"><i class="fa fa-plus-circle"></i></span>
            <input id="buyer_categories" @keydown.enter="addBuyerCategory" type="text"
                   placeholder="Type and press ENTER" class="form-control form-control-sm form-control-solid ps-14"/>
          </div>
          <has-error :form="post" field="buyer_categories"></has-error>
          <div>
            <draggable tag="div" :list="buyer_categories" handle=".handle" @end="reorderedBuyerCategory">
              <div v-for="(c, i) in buyer_categories" class="bg-gray-200 p-2 mb-1">
                <span class=""><i class="fa fa-align-justify handle"></i></span>
                <span>
                  {{ c }}
                </span>
                <span class="ms-3 cursor-pointer" @click="removeCategory('buyer_categories', i)"><i
                    class="fa fa-trash text-danger"></i></span>
              </div>
            </draggable>
          </div>
        </div>
        <div class="col-lg-6">
          <label for="buyer_ranks" class="d-flex align-items-center dm-fs-0-9-rem fw-bold form-label mb-3">Buyer
            Ranks</label>
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6"><i class="fa fa-plus-circle"></i></span>
            <input id="buyer_ranks" @keydown.enter="addBuyerRank" type="text"
                   placeholder="Type and press ENTER" class="form-control form-control-sm form-control-solid ps-14"/>
          </div>
          <has-error :form="post" field="buyer_ranks"></has-error>
          <div>
            <draggable tag="div" :list="buyer_ranks" handle=".handle" @end="reorderedBuyerCategory">
              <div v-for="(c, i) in buyer_ranks" class="bg-gray-200 p-2 mb-1">
                <span class=""><i class="fa fa-align-justify handle"></i></span>
                <span>
                  {{ c }}
                </span>
                <span class="ms-3 cursor-pointer" @click="removeCategory('buyer_ranks', i)"><i
                    class="fa fa-trash text-danger"></i></span>
              </div>
            </draggable>
          </div>
        </div>

      </div>

      <div class="row mb-6">
        <div class="col-lg-6">
          <form-select2
              name="status"
              label="Status"
              :form="post"
              v-model="post.status"
              :options="drdata.project_statuses"
              :config="{
                    label: 'title',
                    searchable: false,
                    clearable: false,
                  }"
              :classes="['form-select-solid form-select-sm']"
          />
          <!--          <form-treeselect v-model="post.status" :options="drdata.project_statuses" label="Status"-->
          <!--                           :config="{id: 'id', label: 'title'}" :form="post" name="status"></form-treeselect>-->
        </div>
        <div class="col-lg-6">
          <label for="engagement_date" class="d-flex align-items-center dm-fs-0-9-rem fw-bold form-label">Engagement Date</label>
          <date-picker id="engagement_date" v-model="post.engagement_date_"
                       :typeable="false"
                         input-class="form-control form-control-sm form-control-solid mb-3"
                         format="DD-MM-YYYY"/>
          <has-error :form="post" field="engagement_date"></has-error>
        </div>
      </div>
      <div class="row mb-6">
        <div class="col-lg-6">
          <form-switch
              name="hide_company_name"
              label="Hide Company Name"
              :form="post"
              v-model="post.hide_company_name"
          />
        </div>
      </div>

      <div class="row mb-6">
        <div class="col-lg-6">
          <form-switch
              name="hide_buyer_tracker"
              label="Hide Buyer Tracker"
              :form="post"
              v-model="post.hide_buyer_tracker"
          />
        </div>
      </div>

    </template>
    <template #footer>
    </template>
  </modal-form-helper>
</template>

<script>
import cm from "@mxn/create"
// import CompanyCreate from "@cc/clients/companies/CompanyCreate.vue"
import CompanyCreate from "@cc/modules/crm/company/CreateCompanyModal.vue";

export default {
  mixins: [cm],
  props: {
    title: '',
    source: '',
    url_key: {
      default: 'projects'
    },
    fetchProjectHelper:{
      type: Function,
      required: false
    },
    company:{},
    introducers: [],
    team_members: [],
  },
  data() {
    return {
      id: this.company ? '' : this.$route.params.id,
      isModal: false,
      // urlKeyName: 'get',

      drdata: {
        companies: [],
        companies_wf: [],
        project_statuses: [],
        transaction_types: [],
        departments: [],
        groups: [],
        users: [],
      },

      project_stages: [],
      post: Form.make({
        name: '',
        company: null,
        status: null,
        project_type: null,
        project_stage: null,
        introducers: [],
        team_members: [],
        company_id: null,
        project_type_id: null,
        introducer_id: null,
        team_member_ids: [],
        hide_company_name: false,
        hide_buyer_tracker: false,
        engagement_date_: null,
        engagement_date: null,
        working_for: null,

        is_buyside_: false,
      }),

      buyer_categories: [],
      buyer_ranks: [],
    };
  },
  watch: {
    'post.project_type': {
      handler(val, oldVal){
        this.calcBuyside()
      },
      deep: true
    }
  },
  mounted() {
    // from prop
    if(this.company){
      this.isModal = true
      this.post.company = this.company.id
      this.fetchHelpers()
    }
    if(this.source == 'quick_menu'){
      this.isModal = true
    }

    // from prop
    if(Array.isArray(this.team_members) && this.team_members){
      this.post.team_members_ = this.team_members
      this.post.update({
        ...this.post,
        team_members: this.team_members.map(tm => tm.id)
      })
    }

    // from prop
    if(Array.isArray(this.introducers) && this.introducers){
      this.post.introducers_ = this.introducers
      this.post.update({
        ...this.post,
        introducers: this.introducers.map(tm => tm.id)
      })
    }

    if(!this.id){
      this.post.engagement_date_ = new Date()
    }

    this.$root.$on("company_created_project", (data) => {
      if (data.id) {
        this.post.update({
          ...this.post,
          company: data.id
        })
      }
      this.fetchHelpers()
    })
  },
  destroyed() {
    this.$root.$off("company_created_project")
  },
  methods: {
    openModal(component, urlKey = null) {
      let component_ = ''
      switch (component) {
        case 'company_create':
          component_ = CompanyCreate
          break
        default:
          throw new Error("component type not in list")
      }

      this.$modal.show(
          component_,
          {
            urlKey,
          },
          {
            height: "auto",
            scrollable: true
          }
      );
    },
    onTrxChange(type_id) {
      axios.get(this.genUrl(this.url_key, null, 'get_project_stages'), {
        params: {
          id: type_id
        }
      })
          .then(({data}) => {
            console.log(data)
            this.project_stages = data.data
          })
          .catch(err => console.error(err))
    },
    removeCategory(type, i) {
      this[type].splice(i, 1)
    },
    addBuyerCategory(e) {
      this.addCategory('buyer_categories', e)
    },
    addBuyerRank(e) {
      this.addCategory('buyer_ranks', e)
    },
    addCategory(type, e) {
      const val = e.target.value
      if (!val.length) return this.toastWarning('Type a name')

      const found = this[type].find(e => e === val)
      if (found) return this.toastWarning('Item exists')

      this[type].push(val)
      e.target.value = ''
    },
    reorderedBuyerCategory(list) {
    },
    reorderedCategory(type, list) {
    },
    preCreate() {
      this.post.update({
        ...this.post,
        buyer_categories: this.buyer_categories,
        buyer_ranks: this.buyer_ranks,
        engagement_date: this.momentMixin(this.post.engagement_date_, 'YYYY-MM-DD'),
      })
    },
    edit() {
      this.startCompLoading()
      axios.get(this.genUrl(this.url_key, this.id, 'post'))
          .then(({data}) => {
            this.post.update({
              ...this.post,
              ...data,
              project_stage: _.get(data.project_stage, 'id'),
              company: _.get(data.company, 'id'),
              working_for: _.get(data.working_for, 'id'),
              project_type: _.get(data.project_type, 'id'),
              status: _.get(data.status, 'id'),
              team_members: _.map(data.team_members, 'id'),
              team_members_: data.team_members,
              introducers: _.map(data.introducers, 'id'),
              introducers_: data.introducers,
              engagement_date_: data.engagement_date ? new Date(data.engagement_date) : null,
            })

            this.buyer_categories = _.map(data.buyer_categories, 'name')
            this.buyer_ranks = _.map(data.buyer_ranks, 'name')

            if(data.working_for){
              this.drdata.companies_wf = [data.working_for]
            }

            this.fetchHelpers()
            this.onTrxChange(this.post.project_type)
            this.calcBuyside()
          })
          .catch(err => console.error(err))
          .finally(() => this.endCompLoading())
    },
    fetchHelpers() {
      axios.get(this.genUrl(this.url_key, null, 'data'), {
        params: {
          company: this.post.company
        }
      })
          .then(({data}) => {
            this.drdata = {
              ...this.drdata,
              ...data,
            }
            this.calcBuyside()

            if(!this.id && this.drdata.project_statuses.length){
              //set active as default
              this.post.status = this.drdata.project_statuses[0].id
            }
          })
          .catch(err => console.error(err))
    },
    postCreate(data) {
      if(this.source == 'quick_menu'){
        this.close()
        return
      }

      if(this.source == 'overview'){
        this.fetchProjectHelper()
        this.close()
        return
      }
      this.$router.push({name: 'project_details', params: {id: data.id}})
    },
    calcBuyside(){
      let buyside_match = 0
      this.drdata.transaction_types.forEach(tx => {
        if(tx.is_buyside && tx.id == this.post.project_type){
          buyside_match++;
        }
      })
      console.log('BUYSIDE_MATCH', buyside_match)
      this.post.update({
        ...this.posst,
        is_buyside_: buyside_match,
      })
    }
  },
};
</script>